import {
  GET_VERIFICATION_CONTEXT_REQUEST,
  GET_VERIFICATION_CONTEXT_SUCCESS,
  GET_VERIFICATION_CONTEXT_ERROR,
  RESET_PAYMENTS,
} from '../actions/payments';

export const initialState = {
  amount: null,
  addPaymentUrl: null,
  clientToken: null,
  exemptionRequested: false,
  isGetVerificationContextInProgress: false,
  isGetVerificationContextError: false,
  paymentBillingInfo: null,
  paymentBin: null,
  paymentMethodNonce: null,
  context: null,
  challengeRequested: false,
};

export default function verificationContextReducer(state = initialState, action) {
  switch (action.type) {
    case GET_VERIFICATION_CONTEXT_REQUEST:
      return {
        ...state,
        isGetVerificationContextInProgress: true,
      };
    case GET_VERIFICATION_CONTEXT_SUCCESS:
      return {
        ...state,
        amount: action.data.amount,
        addPaymentUrl: action.data.context !== 'SLOT_SUB_SIGNUP_RAVEN' ? action.data.addPaymentUrl : null,
        clientToken: action.data.clientToken,
        exemptionRequested: action.data.context === 'CHECKOUT' && action.data.exemptionRequested,
        isGetVerificationContextError: false,
        isGetVerificationContextInProgress: false,
        paymentMethodNonce: action.data.paymentMethodNonce,
        paymentBin: action.data.bin,
        paymentBillingInfo: action.data.billingInfo,
        context: action.data.context,
        challengeRequested: action.data.challengeRequested,
      };
    case GET_VERIFICATION_CONTEXT_ERROR:
      return {
        ...state,
        isGetVerificationContextError: true,
        isGetVerificationContextInProgress: false,
      };
    case RESET_PAYMENTS:
      return initialState;
    default:
      return state;
  }
}
